import { render, staticRenderFns } from "./badgeInfoAdmin.vue?vue&type=template&id=6bdfb152&"
import script from "./badgeInfoAdmin.vue?vue&type=script&lang=js&"
export * from "./badgeInfoAdmin.vue?vue&type=script&lang=js&"
import style0 from "./badgeInfoAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports